/**
 * 正規ビューワ/OGP ページ（サーバの GET /view/{slug}）の URL 導出（M5b-2）。
 *
 * 共有 URL・QR・SNS・埋め込みは、クローラ/SNS が OGP プレビューを得られるよう
 * このサーバ集約ページを指す。ページ URL は manifest の `source`
 * （`…/api/v1/books/{slug}/manifest`）から機械的に導ける:
 *
 *   {prefix}/api/v1/books/{slug}/manifest  →  {prefix}/view/{slug}
 *
 * サブパスマウント（prefix 付き）も保つ。source が標準形でなければ `null` を返し、
 * 呼び出し側は M5b-1 の「現在ページ」挙動へフォールバックする（後方互換）。
 *
 * `viewBase` が指定されていれば origin(+prefix) をそれで上書きする（導入者が
 * 別ホストに OGP ページを置く場合）。空なら source から導出した origin+prefix を使う。
 *
 * `slug` を渡すと**別ブック**の正規ページを組み立てる（カタログ間リンク・EP-2）。
 * 同じ配置規約に載っているブックなら、これだけで到達 URL が決まる。
 */
export function canonicalViewUrl(
  source: string,
  baseHref: string,
  viewBase = '',
  slug?: string,
): string | null {
  let abs: URL;
  try {
    abs = new URL(source, baseHref);
  } catch {
    return null;
  }
  const match = /^(.*)\/api\/v1\/books\/([^/]+)\/manifest$/.exec(abs.pathname);
  if (!match) return null;

  const prefix = match[1] as string; // /api/v1/… の手前（サブパスマウントを保つ）
  const target = slug ?? (match[2] as string);
  const trimmedViewBase = viewBase.replace(/\/+$/, '');
  const originAndPrefix = trimmedViewBase !== '' ? trimmedViewBase : `${abs.origin}${prefix}`;
  return `${originAndPrefix}/view/${encodeURIComponent(target)}`;
}
